import { FC } from 'react';
import type { RegulationData } from 'state/quotes/dashboard/model';

import { RegulationIndicator } from './RegulationIndicator';

export const RegulationPanel: FC<{ data: RegulationData }> = ({ data }) => {
  return (
    <div className="d-flex">
      <RegulationIndicator label="kid" status={data.kid} className="mx-1 p-1" />
      <RegulationIndicator label="tm" status={data.tm} className="mx-1  p-1" />
    </div>
  );
};

RegulationPanel.displayName = 'RegulationPanel';
